const { OVERLAY_RECURRINGSAVING, OVERLAY_RECURRINGINCOME } = require("./LoanConstants");
const finance = require("financejs");
const moment = require("moment");

const monthFormat = "MM/YYYY";
const dayFormat = "D-MMM-YYYY";

class Loan {
  /**
   * Constructor parameters
   *
   * @param rate                Rate of interest, 100-based (15% = 15), per period.
   * @param tenor               Length of loan in months.
   * @param principal           Loan amount.
   * @param startDate           Loan start date.
   * @param gracePeriod         Grace period of loan
   * @param overlays            Array of extra payments
   * @param name                Loan name
   * @param color               Loan color
   * Overlays
   *  @param type                Extra payment type: 'onetimesaving', 'recurringsaving', 'onetimeincome', 'recurringincome'
   *  @param amount              Extra payment amount
   *  @param startDate    Extra payment start date
   * @return                    Amortization schedule.
   */

  constructor(rate, tenor, principal, startDate, gracePeriod = 0, overlays = [], name = "Default loan", color = "#ffffff") {
    this.rate = rate;
    this.tenor = tenor;
    this.principal = principal;
    this.startDate = new Date(startDate);
    this.gracePeriod = gracePeriod;
    this.overlays = overlays;
    this.name = name;
    this.color = color;
  }

  calculateMonthlyPayment() {
    return this.PMT(this.rate, this.tenor, this.principal);
  }

  calculateMonthlyPaymentWithOverlays() {
    let overlayPmt = 0;
    if (this.overlays.length > 0) {
      this.overlays.forEach(overlay => {
        if (overlay.type === OVERLAY_RECURRINGINCOME || overlay.type === OVERLAY_RECURRINGSAVING) {
          overlayPmt += overlay.amount;
        }
      });
    }
    // If recurring
    return this.PMT(this.rate, this.tenor, this.principal) + overlayPmt;
  }

  calculateRoundedMonthlyPayment() {
    return parseFloat(this.PMT(this.rate, this.tenor, this.principal).toFixed(2));
  }

  getAggregateOverlayForADate(date) {
    let total = 0;
    if (this.overlays && this.overlays.length > 0) {
      // console.log("overlays: ", this.overlays);

      // eslint-disable-next-line no-loop-func
      this.overlays.forEach(overlay => {
        // console.log(`DATE: ${date} OVERLAY: ${JSON.stringify(overlay)}`);

        if (overlay.enabled) {
          // Recurring payments
          // console.log("overlay: ", overlay);
          // console.log('start date: ', date);

          // let date = moment(this.startDate, dayFormat).startOf("month");

          if (overlay.type === OVERLAY_RECURRINGSAVING || overlay.type === OVERLAY_RECURRINGINCOME) {
            if (moment(overlay.startDate, dayFormat).startOf("month") <= moment(date, dayFormat)) {
              // console.log("Overlay type: ", overlay.type);
              total += overlay.amount;
            }
          }
          // One-time payments
          else {
            // console.log("one time payment");
            // console.log(
            //   'one ime pay match date: ',
            //   moment(date, monthFormat).format(monthFormat)
            // );
            // console.log(
            //   'one ime pay match overlay date: ',
            //   moment(overlay.startDate, monthFormat).format(
            //     monthFormat
            //   )
            // );

            if (moment(overlay.startDate, dayFormat).format(dayFormat) === moment(date, dayFormat).format(dayFormat)) {
              // console.log(
              //   'one time pay match dates',
              //   moment(date, monthFormat)
              // );
              total += overlay.amount;
            }
          }
        }
      });
    }
    return total;
  }

  // Calculate amortization schedule
  getAmortization(prettyPrint = false) {
    // console.log("START AMO");
    // console.log("Loan: ", this.principal);
    // console.log("Start date: ", this.startDate);
    // console.log("Moment start date: ", moment(this.startDate, dayFormat));
    // console.log("Moment start date formatted: ", moment(this.startDate, dayFormat).format(dayFormat));

    let month = 0;
    let interestAmount = 0;
    let monthlyPayment = 0;
    let principalAmount = 0;
    let outstandingBalance = this.principal;
    let date = moment(this.startDate, dayFormat).startOf("month");
    let gracePeriod = this.gracePeriod;
    const schedules = [];
    const monthlyInterestRate = this.rate / 12 / 100;
    const numberOfPayments = gracePeriod === 0 ? this.tenor : gracePeriod + this.tenor;

    // let paymentNumber = 0;
    while (outstandingBalance > 0) {
      if (gracePeriod > 0) {
        gracePeriod--;
      } else {
        monthlyPayment = this.PMT(this.rate, this.tenor, this.principal);
        interestAmount = outstandingBalance * monthlyInterestRate;
        principalAmount = monthlyPayment - interestAmount;

        // Subtract principal and any overlays
        let _ob = this.getAggregateOverlayForADate(date) + principalAmount;

        if ((outstandingBalance - _ob).toFixed(0) > 0) {
          outstandingBalance -= _ob;
        } else {
          outstandingBalance = 0;
        }

        // if (prettyPrint) {
        //   console.log(
        //     `#${month}. Date: ${moment(date).format(monthFormat)} Payment: ${Math.round(monthlyPayment)} Balance: ${Math.round(
        //       outstandingBalance
        //     )} -= ${Math.round(this.getAggregateOverlayForADate(date))} + ${Math.round(principalAmount)}`
        //   );
        // }

        // if (this.principal === 10000 || this.principal === 40000) {
        // console.log(
        //   `${this.principal}:#${paymentNumber}@${date}$${outstandingBalance}overlays: ${this.getAggregateOverlayForADate(date)}`
        // );
        // }

        // if (outstandingBalance < 0) {
        //   outstandingBalance = 0;
        // }
      }

      let dtStr = date.format(dayFormat);
      // console.log("Date string: ", dtStr);

      schedules.push({
        date: dtStr,
        month,
        monthlyPayment,
        principalAmount,
        extraPrincipal: this.getAggregateOverlayForADate(date),
        interestAmount,
        percentTowardsPrincipal: (principalAmount / monthlyPayment) * 100,
        outstandingBalance: outstandingBalance >= 0 ? outstandingBalance : 0
      });

      // console.log('date before adding 1 mo: ', date.format(dayFormat));
      date = date.add(1, "months");
      // console.log('date after adding 1 mo: ', date.format(dayFormat));

      month++;
      // paymentNumber++;
    }

    // for (let paymentNumber = 0; paymentNumber <= numberOfPayments; paymentNumber++) {
    //   schedules.push({
    //     date,
    //     month,
    //     monthlyPayment,
    //     principalAmount,
    //     interestAmount,
    //     outstandingBalance
    //   });
    //   if (gracePeriod > 0) {
    //     gracePeriod--;
    //   } else {
    //     monthlyPayment = this.PMT(this.rate, this.tenor, this.principal);
    //     interestAmount = outstandingBalance * monthlyInterestRate;
    //     principalAmount = monthlyPayment - interestAmount;

    //     // Subtract principal and any overlays

    //     outstandingBalance -= this.getAggregateOverlayForADate(date) + principalAmount;

    //     if (this.principal === 10000) {
    //       console.log(
    //         `Payment ${paymentNumber} at date ${date} principal balance ${outstandingBalance} aggregate overlays: ${this.getAggregateOverlayForADate(
    //           date
    //         )}`
    //       );
    //     }

    //     if (outstandingBalance < 0) {
    //       outstandingBalance = 0;
    //     }
    //   }

    //   // console.log('date before adding 1 mo: ', date);
    //   date = moment(date, monthFormat).add(1, "months");
    //   // console.log('date after adding 1 mo: ', date);

    //   month++;
    // }
    if (this.principal === 0) {
      schedules.push({
        date: moment(new Date(), dayFormat).format(dayFormat),
        month,
        monthlyPayment,
        principalAmount,
        extraPrincipal: 0,
        interestAmount: 0,
        percentTowardsPrincipal: 100,
        outstandingBalance: 0
      });
    }

    return schedules;
    //   return schedules.map(schedule => {
    //     console.log('Schedule: ', schedule);

    //     // console.log("Date: ", schedule.date.format(dayFormat));
    //     // console.log("Date: ", schedule.date.format(dayFormat));
    //     // console.log("Date: ", moment(schedule.date, dayFormat).format(dayFormat));

    //     return {
    //       // date: moment(schedule.date, dayFormat).format(dayFormat),
    //       // date: date.format(dayFormat),
    //       date: schedule.date,
    //       month: schedule.month,
    //       monthlyPayment: schedule.monthlyPayment,
    //       principalAmount: schedule.principalAmount,
    //       interestAmount: schedule.interestAmount,
    //       outstandingBalance: Math.abs(Math.ceil(schedule.outstandingBalance))
    //     };
    //   });
  }

  // Calculate total interest paid
  getTotalInterest() {
    let totalInterest = 0;
    const amortizations = this.getAmortization();
    amortizations.forEach(payment => {
      totalInterest += payment.interestAmount;
    });
    return totalInterest;
  }

  addOverlay(overlay) {
    this.overlays.push(overlay);
  }

  setOverlays(overlays) {
    this.overlays = [];
    overlays.forEach(overlay => this.overlays.push(overlay));
  }

  // Get number of monthly payments
  getTotalMonths() {
    const amortizations = this.getAmortization();
    return amortizations[amortizations.length - 1].month;
  }

  // Calculate maturity date of a loan
  calculateMaturityDate() {
    const amortizations = this.getAmortization();

    // console.log("--------------------");
    // console.log(`Amort for loan ${this.principal}: ${JSON.stringify(amortizations)}`);
    // console.log("--------------------");
    return amortizations[amortizations.length - 1].date;

  }

  /**
   * Loan Payment Per Period (PMT).
   * Payment for a loan based on constant payments and a constant interest rate.
   *
   * @param rate      Rate of interest, 100-based (15% = 15), per period.
   * @param tenor     Length of loan in months.
   * @param principal Loan amount.
   * @return          Monthly payment amount.
   * @see             {@link http://www.financeformulas.net/Loan_Payment_Formula.html}
   */
  PMT(rate, tenor, principal) {
    const monthlyInterestRate = rate / 12 / 100;
    const financejs = new finance.Finance();
    return financejs.PMT(monthlyInterestRate, tenor, -principal);
  }
}

module.exports = Loan;
